/** Must match `assets/session-bridge/portal-session-bridge.html` — `storage` on Portal origin wakes DejaUp iframe. */
export const IPP_PORTAL_SESSION_BRIDGE_LOGOUT_KEY = 'ipp_portal_session_bridge_logout';

/** Must match vms `auth.service.ts` / `main.ts` ({@link SSO_LOGOUT_POST_MESSAGE}). */
export const IPP_SSO_LOGOUT_POST_MESSAGE = 'IPP_SSO_LOGOUT';
